// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".player-info{text-align:center;font-size:7pt}.white-text{color:#fff}.block{display:block}@media only screen and (max-width: 400px)and (max-height: 750px),screen and (max-width: 780px)and (max-height: 400px){.player-info{font-size:8pt}}", ""]);
// Exports
module.exports = exports;
